<div class="individual-card" (click)="onCardClick()">
  <div class="header">
    <div class="avatar">{{ initials }}</div>
    <div class="header-info">
      <b class="username">{{ userName }}</b>
      <div class="date">{{ assessment.session.date | date:'mediumDate' }}</div>
    </div>
  </div>

  <div echarts [options]="chartOption" class="radar-chart"></div>
  
  <div class="info">
    <div>
      <span>Score: </span>
      <span class="score">{{ score }}/{{ scoreMax }}</span>
    </div>
    <div>
      <span>Duration: </span>
      <span class="score">{{ assessment.session.duration | durationConverter }}</span>
    </div>
  </div>
</div>
